import React, { Component } from "react";
import _ from "lodash";
import { renderMarkup } from "../utils.js";

class OurTeam extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="team bg-gray">
        <h2>Our Team</h2>
        <div className="inner">
          <div className="team-col">
            <h4>Management</h4>
            {_.map(data.team_members, (team, i) => {
              if (team.department === "Management") {
                return (
                  <div key={i} className="team-member">
                    {team.portrait && (
                      <img src={team.portrait} alt="Team Member" />
                    )}
                    <div dangerouslySetInnerHTML={renderMarkup(team.info)} />
                  </div>
                );
              }
            })}
          </div>
          <div className="team-col">
            <h4>administration & production</h4>
            {_.map(data.team_members, (team, i) => {
              if (team.department === "administration & production") {
                return (
                  <div key={i} className="team-member">
                    {team.portrait && (
                      <img src={team.portrait} alt="Team Member" />
                    )}
                    <div dangerouslySetInnerHTML={renderMarkup(team.info)} />
                  </div>
                );
              }
            })}
          </div>
          <div className="team-col">
            <h4>Sales</h4>
            {_.map(data.team_members, (team, i) => {
              if (team.department === "Sales") {
                return (
                  <div key={i} className="team-member">
                    {team.portrait && (
                      <img src={team.portrait} alt="Team Member" />
                    )}
                    <div dangerouslySetInnerHTML={renderMarkup(team.info)} />
                  </div>
                );
              }
            })}
          </div>
          <div className="team-col">
            <h4>Development</h4>
            {_.map(data.team_members, (team, i) => {
              if (team.department === "Development") {
                return (
                  <div key={i} className="team-member">
                    {team.portrait && (
                      <img src={team.portrait} alt="Team Member" />
                    )}
                    <div dangerouslySetInnerHTML={renderMarkup(team.info)} />
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default OurTeam;



// WEBPACK FOOTER //
// ./src/components/OurTeam.js